import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router";
import useFlash from "go-alert/AlertMessage";
import handleError from "go-app/services/errors";
import RequestItemPreview from "go-component/components/RequestItem/RequestItemPreview";
import { RequestItemContext } from "go-component/components/RequestItem/services/context";
import { RequestItemApi } from "go-component/components/RequestItem/services/types";
import { parseApiData } from "go-core/api/parseApiData";
import { LoadingContainer } from "go-core/components/Loading";

interface MatchParams {
	item_id: string;
}

const OrganizationLogsRequestItemsPreviewPage = () => {
	const [requestItem, setRequestItem] = useState<RequestItemApi | undefined>();
	const requestItemService = useContext(RequestItemContext);
	const { addFlash } = useFlash();
	const { item_id } = useParams<MatchParams>();

	const init = async () => {
		const params = { include: "logs,settings" };
		try {
			const res = await parseApiData(requestItemService.api().get(item_id, params));
			setRequestItem(res);
		} catch (err) {
			handleError.alert(err, addFlash);
		}
	};

	useEffect(() => {
		init();
	}, []);

	if (!requestItem) {
		return <LoadingContainer />;
	}

	return <RequestItemPreview requestItem={requestItem} />;
};

export default OrganizationLogsRequestItemsPreviewPage;
